(function() {
    'use strict';

    angular.module('app.accionesPersonal', []);
})();
